<template>
  <div class="economize-wrap">
    <div class="btn-content" id="editor">
      <el-button @click="savePdf2">打印pdf</el-button>
    </div>
    <div class="economize-content" id="render_me">
      <!-- <div class="report-title">节能空间分析报告</div> -->
      <div class="pdf-con" id="imageDom" ref="imageDom">
        <div
          class="contentTwo"
          style="display: flex;flex-flow: column;align-items: center;justify-content: center;"
        >
          <p
            style="font-size: 30px;text-align: center;font-weight: bold;"
          >{{dataAll.cover.projectName}}</p>
          <p style="font-size: 30px;text-align: center;padding: 10px 0px;">{{dataAll.cover.title}}</p>
          <p style="font-size: 18px;text-align: center;">{{dataAll.cover.time}}</p>
        </div>
        <div class="content" style="height: 1060px;">
          <p class="report-title">1.变压器概况</p>
          <table class="report-table" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <td>站点名称</td>
              <td colspan="3">{{dataAll.descriptionOfProject.projectName}}</td>
            </tr>
            <tr>
              <td>站点名称</td>
              <td colspan="3">{{dataAll.descriptionOfProject.address}}</td>
            </tr>
            <tr>
              <td>总容量</td>
              <td>电压等级</td>
              <td>主变台数</td>
              <td>检测点数</td>
            </tr>
            <tr>
              <td>{{dataAll.descriptionOfProject.totalCapacity}}</td>
              <td>{{dataAll.descriptionOfProject.voltageGrade}}</td>
              <td>{{dataAll.descriptionOfProject.numberOfTransformers}}</td>
              <td>{{dataAll.descriptionOfProject.monitoringStations}}</td>
            </tr>
          </table>
          <p class="report-title">2.用电量分析</p>
          <p class="report-title report-title-2">2.1 日耗电量分析</p>
          <div
            class="item-content"
          >{{dataAll.electricityConsumptionAnalysis.monthElectricityConsumption.preDescribe}}</div>
          <div class="echart-content">
            <div id="echartOne" style="width:100%;height:100%"></div>
          </div>
          <p class="report-title report-title-2">2.2 线路能耗排名</p>
          <div class="echart-content">
            <div id="echartTwo" style="width:100%;height:100%"></div>
          </div>
        </div>
        <div class="content" style="height: 1150px;">
          <p class="report-title">3.变压器运行情况</p>
          <table class="report-table" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <td>变压器名称</td>
              <td>最大负荷(kW)</td>
              <td>最小负荷(kW)</td>
              <td>平均负荷(kW)</td>
            </tr>
            <tr v-for="(item,index) in  dataAll.transformerOperationalAspect.table" :key="index">
              <td>{{item.name}}</td>
              <td>{{item.max}}</td>
              <td>{{item.min}}</td>
              <td>{{item.avg}}</td>
            </tr>
          </table>
        </div>

        <div
          class="contentOne"
          style=" height: 1150px"
          v-for="(item,index) in dataAll.transformerOperationalAspect.childrenSection"
          :key="index"
        >
          <p class="report-title report-title-2">3.{{index+1}} {{item.title}}</p>
          <p class="report-title report-title-3">3.{{index+1}}.1 日负荷分析</p>
          <div>
            <echartsItem :chartData="item.loadAnalyze.echarts"></echartsItem>
          </div>
          <div class="item-content">{{item.loadAnalyze.rearDescribe}}</div>
          <p class="report-title report-title-3">3.{{index+1}}.2 日功率因数分析</p>
          <div>
            <echartsItem :chartData="item.powerFactorAnalyze.echarts"></echartsItem>
          </div>
          <div class="item-content">{{item.powerFactorAnalyze.rearDescribe}}</div>
        </div>
        <div class="content" style="height: 1000px;">
          <p class="report-title">4.事件统计</p>
          <p class="report-title report-title-2">4.1 遥测越限事件</p>
          <div class="item-content">{{dataAll.eventStatistics.preDescribe}}</div>
          <table class="report-table" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <td>告警类型</td>
              <td>告警编码</td>
              <td>告警数量</td>
            </tr>
            <tr v-for="(item,index) in dataAll.eventStatistics.table" :key="index">
              <td>{{item.alarmType}}</td>
              <td>{{item.alarmCode}}</td>
              <td>{{item.count}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import echartsItem from "./echart/ehartsItem";
import {handleWindowPrint} from "./print";
export default {
  components: {
    echartsItem
  },
  props: {
    data: {
      type: String,
      default: () => {}
    },
    downLoadName: {
      type: String,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: () => {}
    }
  },
  watch: {
    data(e) {
      console.log(e);
      this.dataAll = JSON.parse(this.data);
      console.log(this.dataAll);
    }
  },
  data() {
    return {
      dataAll: {},
      chartData: null,
      echartOne: null,
      echartTwo: null,
      echartThree: null,
      echartFour: null,
      echartFive: null,
      echartSix: null,
      Name: ""
    };
  },
  created() {
    // console.log(this.dataAll);
    // console.log(this.data);
    // console.log(JSON.parse(this.data));
    this.Name = this.downLoadName;
    this.dataAll = JSON.parse(this.data);
    console.log(this.dataAll);
  },
  mounted() {
    // console.log(
    //   this.dataAll.electricityConsumptionAnalysis.monthElectricityConsumption
    //     .echarts.y
    // );
    // console.log(
    //   this.dataAll.electricityConsumptionAnalysis.monthElectricityConsumption
    //     .echarts.x
    // );

    this.getEchart(
      "echartOne",
      this.echartOne,
      this.dataAll.electricityConsumptionAnalysis.monthElectricityConsumption
        .echarts.y,
      this.dataAll.electricityConsumptionAnalysis.monthElectricityConsumption
        .echarts.x,
      this.dataAll.electricityConsumptionAnalysis.monthElectricityConsumption
        .echarts.title,
      this.dataAll.electricityConsumptionAnalysis.monthElectricityConsumption
        .echarts.unit,
      this.dataAll.electricityConsumptionAnalysis.monthElectricityConsumption
        .echarts.title,
      "bar",
      "日期"
    );
    this.getEchart(
      "echartTwo",
      this.echartTwo,
      this.dataAll.electricityConsumptionAnalysis.energyConsumptionRanking.y,
      this.dataAll.electricityConsumptionAnalysis.energyConsumptionRanking.x,
      this.dataAll.electricityConsumptionAnalysis.energyConsumptionRanking
        .title,
      this.dataAll.electricityConsumptionAnalysis.energyConsumptionRanking.unit,
      this.dataAll.electricityConsumptionAnalysis.energyConsumptionRanking
        .title,
      "bar",
      "部门"
    );
    // this.getEchart(
    //   "echartThree",
    //   this.echartThree,
    //   this.electricalCharacteristics.powerUsageAnalysis.powerFactor.echarts.y,
    //   this.electricalCharacteristics.powerUsageAnalysis.powerFactor.echarts.x,
    //   this.electricalCharacteristics.powerUsageAnalysis.powerFactor.echarts
    //     .title,
    //   this.electricalCharacteristics.powerUsageAnalysis.powerFactor.echarts
    //     .unit,
    //   this.electricalCharacteristics.powerUsageAnalysis.powerFactor.echarts
    //     .subtitle,
    //   "line"
    // );
    // this.getEchart(
    //   "echartFour",
    //   this.echartFour,
    //   this.electricalCharacteristics.powerUsageAnalysis.transformerLoadRatio
    //     .echarts.y,
    //   this.electricalCharacteristics.powerUsageAnalysis.transformerLoadRatio
    //     .echarts.x,
    //   this.electricalCharacteristics.powerUsageAnalysis.transformerLoadRatio
    //     .echarts.title,
    //   this.electricalCharacteristics.powerUsageAnalysis.transformerLoadRatio
    //     .echarts.unit,
    //   this.electricalCharacteristics.powerUsageAnalysis.transformerLoadRatio
    //     .echarts.subtitle,
    //   "bar"
    // );
    // this.getEchart(
    //   "echartFive",
    //   this.echartFive,
    //   this.electricalCharacteristics.powerUsageAnalysis.voltageImbalance.echarts
    //     .y,
    //   this.electricalCharacteristics.powerUsageAnalysis.voltageImbalance.echarts
    //     .x,
    //   this.electricalCharacteristics.powerUsageAnalysis.voltageImbalance.echarts
    //     .title,
    //   this.electricalCharacteristics.powerUsageAnalysis.voltageImbalance.echarts
    //     .unit,
    //   this.electricalCharacteristics.powerUsageAnalysis.voltageImbalance.echarts
    //     .subtitle,
    //   "bar"
    // );
    // this.getEchart(
    //   "echartSix",
    //   this.echartSix,
    //   this.electricalCharacteristics.loadCharacteristicAnalysis.echarts.y,
    //   this.electricalCharacteristics.loadCharacteristicAnalysis.echarts.x,
    //   this.electricalCharacteristics.loadCharacteristicAnalysis.echarts.title,
    //   this.electricalCharacteristics.loadCharacteristicAnalysis.echarts.unit,
    //   this.electricalCharacteristics.loadCharacteristicAnalysis.echarts
    //     .subtitle,
    //   "line"
    // );
  },
  methods: {
    getEchart(id, chartName, data, xdata, title, unit, legend, type, xname) {
      // console.log(legend);
      // if(legend instanceof Array)
      console.log(legend instanceof Array);
      let legendtitle = legend;
      if (legendtitle instanceof Array) {
        legendtitle = legend;
        // console.log(legendtitle);
      } else {
        legendtitle = [legend];
        // legendtitle.push(legend);
        // console.log(legendtitle);
      }
      let dataAll = true;
      let dataseries = [];
      let icon = ["diamond", "rect", "triangle"];
      // console.log(typeof data[0]);
      if (typeof data[0] != "string") {
        for (let i = 0; i < data.length; i++) {
          dataseries.push({
            name: legend[i],
            data: data[i],
            type: type,
            symbol: icon[i]
            // legend: icon[i]
          });
        }
        // console.log(dataseries);
      } else {
        dataseries = [
          {
            name: legend,
            data: data,
            type: type
          }
        ];
        // console.log(dataseries);
        // console.log("222");
      }
      let this_ = this;
      chartName = this.$echarts.init(document.getElementById(id));
      var option = {
        title: {
          text: title,
          left: "center"
        },
        grid: {
          x: 70,
          y: 50,
          x2: 50,
          y2: 60,
          borderWidth: 10,
          width: "70%"
        },
        color: [
          "#d2b533",
          "#fe3c00",
          "#7928cb",
          "#8eb2f0",
          "#003690",
          "#0db198",
          "#9ff093"
        ],
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: legendtitle,
          top: "20%",
          right: "1%",
          orient: "vertical" //垂直显示
          // icon: ["line", "pin", "diamond"]
        },

        // dataZoom: [
        //   {
        //     type: "inside",
        //     show: true,
        //     realtime: true
        //   },
        //   {
        //     show: true,
        //     realtime: true,
        //     end: 100,
        //     type: "slider",
        //     width: "92%",
        //     left: "center"
        //   }
        // ],
        // toolbox: {
        //   show: true,
        //   feature: {
        //     // dataView: { show: true, readOnly: false },
        //     magicType: { show: true, type: ["line", "bar"] },
        //     // restore: { show: true },
        //     saveAsImage: { show: true }
        //   }
        // },
        calculable: true,
        xAxis: [
          {
            type: "category",
            data: xdata,
            name: xname
          }
        ],
        yAxis: [
          {
            type: "value",
            name: unit
          }
        ],
        series: dataseries
      };

      chartName.setOption(option, true);
      if (chartName) {
        window.addEventListener("resize", function() {
          chartName.resize();
        });
      }
    },

    savePdf() {
      let scrollHeight = this.$refs.imageDom.scrollHeight;
      document.querySelector("#imageDom").style.height = scrollHeight + "px";
      var title = this.Name;
      html2Canvas(document.querySelector("#imageDom"), {
        allowTaint: true,
        taintTest: false,
        height: this.$refs.imageDom.scrollHeight
      }).then(function(canvas) {
        console.log(canvas);
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 595.28;
        let imgHeight = (592.28 / contentWidth) * contentHeight;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);
        let PDF = new JsPDF("", "pt", "a4");
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        PDF.save(title + ".pdf");
        document.querySelector("#imageDom").style.height = "calc(100% - 60px)";
      });
    },
    savePdf2() {
      var canvass = document.querySelectorAll("#imageDom canvas");
      var noneCanvasImg = document.querySelectorAll(".none-canvas-img");
      let name = this.Name;
      for (let index = 0; index < noneCanvasImg.length; index++) {
        const element = noneCanvasImg[index];
        // 判断是否是IE
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          element.removeNode(true);
        } else {
          element.remove();
        }
      }
      let index = 0;

      for (let k4 = 0; k4 < canvass.length; k4++) {
        let imageURL = canvass[k4].toDataURL("image/png");
        let img = document.createElement("img");
        img.src = imageURL;
        img.setAttribute("style", "max-width: 100%;");
        img.setAttribute("index", k4);
        img.className = "isNeedRemove none-canvas-img";
        // canvass[k4].style.display = 'none'
        // canvass[k4].parentNode.style.width = '100%'
        // canvass[k4].parentNode.style.textAlign = 'center'
        img.onload = function(e) {
          index++;
          const imgIndex = e.currentTarget.attributes.index.value;
          canvass[imgIndex].parentNode.insertBefore(
            img,
            canvass[imgIndex].nextElementSibling
          );
          if (index == canvass.length) {
            const style = `.economize-wrap {
                                              min-width: 794px;
                                              margin: 0px auto;
                                              height: 100%;
                                              overflow: hidden;
                                            }
                                            .btn-content {
                                              padding-bottom: 10px;
                                              padding-left: 10px;
                                              padding-right: 10px;
                                              margin-bottom: 10px;
                                              text-align: right;
                                              border-bottom: 1px solid #e4e7ed;
                                            }
                                            .economize-content {
                                              width: 100%;
                                              margin: 0px auto;
                                              height: calc(100% - 60px);
                                              overflow: auto;
                                            }
                                            .pdf-con {
                                              width: 794px;
                                              margin: 0px auto;
                                            }
                                            .report-title {
                                              font-size: 30px;
                                              text-align: center;
                                              line-height: 1110px;
                                            }
                                         .content {
                                              margin-bottom: 10px;
                                              width: calc(100% - 60px);
                                              height: 1120px;
                                              padding: 30px 30px;
                                              // overflow: hidden;
                                              // border: 1px solid #e4e7ed;
                                            }
                                            .contentOne {
                                              margin-bottom: 10px;
                                              width: calc(100% - 40px);
                                              padding: 0px 20px;
                                              // height: 1100px;
                                              height: 1120px;
                                              // overflow: hidden;
                                              // border: 1px solid #e4e7ed;
                                            }
                                            .contentTwo {
                                              margin-bottom: 10px;
                                              width: calc(100% - 40px);
                                              padding: 0px 20px;
                                              // height: 1100px;
                                              height: 1120px;
                                              // overflow: hidden;
                                              // border: 1px solid #e4e7ed;
}
                                            .report-table {
                                              width: 100%;
                                            }
                                            
                                            .report-table tr {
                                              height: 30px;
                                              line-height: 30px;
                                            }
                                            
                                            .report-table tr td {
                                              text-align: center;
                                            }
                                            
                                            .report-title {
                                              padding: 10px 0px;
                                              height: 30px;
                                              line-height: 30px;
                                              font-size: 24px;
                                              text-align: left;
                                              font-weight: bold;
                                              margin: 5px;
                                            }
                                            
                                            .report-title-2 {
                                              font-size: 22px;
                                            }
                                            
                                            .report-title-3 {
                                              font-size: 20px;
                                            }
                                            
                                            .item-content {
                                              width: 100%;
                                              text-indent: 30px;
                                              line-height: 30px;
                                            }
                                            
                                            .echart-content {
                                              width: 100%;
                                              height: 300px;
                                            }`;
            handleWindowPrint("#imageDom", name, style, this);
          }
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.economize-wrap {
  min-width: 794px;
  margin: 0px auto;
  height: 100%;
  overflow: hidden;
}
.btn-content {
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
  text-align: right;
  border-bottom: 1px solid #e4e7ed;
}
.economize-content {
  width: 100%;
  margin: 0px auto;
  height: calc(100% - 60px);
  overflow: auto;
  position: absolute;
}
.pdf-con {
  width: 794px;
  margin: 0px auto;
}
.report-title {
  font-size: 30px;
  text-align: center;
  line-height: 1130px;
}
.content {
  margin-bottom: 10px;
  width: calc(100% - 60px);
  height: 1120px;
  padding: 30px 30px;
  // overflow: hidden;
  border: 1px solid #e4e7ed;
}
.contentOne {
  margin-bottom: 10px;
  width: calc(100% - 40px);
  padding: 0px 20px;
  // height: 1100px;
  height: 1180px;
  // overflow: hidden;
  border: 1px solid #e4e7ed;
}
.contentTwo {
  margin-bottom: 10px;
  width: calc(100% - 40px);
  padding: 0px 20px;
  // height: 1100px;
  height: 1120px;
  // overflow: hidden;
  border: 1px solid #e4e7ed;
}
.report-table {
  width: 100%;
}

.report-table tr {
  height: 30px;
  line-height: 30px;
}

.report-table tr td {
  text-align: center;
}

.report-title {
  padding: 10px 0px;
  height: 30px;
  line-height: 30px;
  font-size: 24px;
  text-align: left;
  font-weight: bold;
  margin: 0px;
}

.report-title-2 {
  font-size: 22px;
}

.report-title-3 {
  font-size: 20px;
}

.item-content {
  width: 100%;
  text-indent: 30px;
  line-height: 30px;
  white-space: initial;
  text-align: left;
}

.echart-content {
  width: 100%;
  height: 300px;
}
</style>
<style>
@media print {
  .list-content {
    display: none;
  }
  .tab-content {
    display: none;
  }
  .wrap-print {
    display: none;
  }
}
</style>
